import React, { useState } from "react";
import SplashScreen from "./components/SplashScreen";
import ProfileModal from "./components/ProfileModal";
import ProjectsSection from "./components/ProjectsSection";
import ProjectModal from "./components/ProjectModal";
import ContactSection from "./components/ContactSection";
import AboutMeSection from "./components/AboutMeSection";
import ProfileCard from "./components/ProfileCard";
const App = () => {
  const [showProfile, setShowProfile] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
  };

  return (
    <>
      <SplashScreen onProfileClick={() => setShowProfile(true)} />
      <AboutMeSection />
      <ProfileCard onProfileClick={() => setShowProfile(true)} />
      <ProjectsSection onProjectClick={handleProjectClick} />
      <ContactSection />

      {showProfile && <ProfileModal onClose={() => setShowProfile(false)} />}
      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </>
  );
};

export default App;
